var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeDia"},[_c('div',{staticClass:"mm",attrs:{"data-scrollbar":""}},[_c('p',[_vm._v(_vm._s(_vm.$t('home').about.text4))])])])}
var staticRenderFns = []

export { render, staticRenderFns }